var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.refresh)?_c('div',{ref:"mychart",staticClass:"chart",attrs:{"id":"mychart"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }